export default "__VITE_ASSET__4697cfe4__"